const doc = [({"en":({"js":({"admin":({"organizations":({"index":({"add_new_organization":"Add new organization", "the_organization_was_deleted":"The organization was deleted"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;